import { RouteConstants } from 'app/routes';
import { useParams, useRouteMatch } from 'react-router-dom';

export const useGetCreateOrUpdateTaskParams = () => {
  const params = useParams<{
    taskId: string;
    fieldId?: string;
  }>();

  const isEditPage = useRouteMatch(RouteConstants.task.editTask);

  const isCreateTaskFromFieldDetailsPage = useRouteMatch(
    RouteConstants.field.createTaskOnField,
  );

  const taskId = Number.isNaN(Number(params.taskId))
    ? undefined
    : Number(params.taskId);

  const fieldId = Number.isNaN(Number(params.fieldId))
    ? undefined
    : Number(params.fieldId);

  return {
    isEditPage: Boolean(isEditPage),
    isCreateTaskFromFieldDetailsPage: Boolean(isCreateTaskFromFieldDetailsPage),
    taskId,
    fieldId,
  };
};
